import React, { useEffect, useState } from 'react'
import { StageBugReport } from '../../../../../utils/dbModels'
import { getProfilePictureByUserId, getUserDataById } from '../../../../../utils/requestsUtils/functionsRequests/user/userFunctions'
import "./CardUserBugReport.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

type CardUserBugReportProps = {
    id: string
    stage?: StageBugReport
}

type UserCardData = {
    name: string
    gimScore: string
    gimmerScore: string
    email: string
}

const CardUserBugReport = ({ id, stage }: CardUserBugReportProps) => {

    const [user, setUser] = useState<UserCardData | null>(null)
    const [imgUrl, setImgUrl] = useState("")

    useEffect(() => {
      
        const getData = () => {
            getUserDataById(id, { mail: 1, phoneNumber: 1, firstName: 1, lastName: 1, gimmerScore: 1, gimScore: 1 }, stage)
            .then((user: any) => {
                setUser({
                    name: `${user.firstName} ${user.lastName}`,
                    gimScore: user.gimScore?.toFixed(2) ?? "",
                    gimmerScore: user.gimmerScore?.toFixed(2) ?? "",
                    email: user.mail ?? "",
                })
            }).catch((error) => {  })

            getProfilePictureByUserId(id, "small", stage)
            .then((url) => {
                setImgUrl(url)
            }).catch(() => {
    
            })
        }

        getData()

    }, [])
    

    return (
        <div className="card-user-bug-report center ml-8 border-radius-6">
            <div className="flex">

                <div className="flex">
                    <img 
                        src={imgUrl ?? "/assets/images/profilePic.png"} 
                        className="img-card-user-bug-report circle" 
                        onError={(e) => { (e.target as HTMLImageElement).src = "/assets/images/profilePic.png" }}    
                    />
                    <div className="flex flex-d-column flex-jc-sb ml-16" >
                        <p className="fs-14 fw-500 color-dark-gim">{user?.name}</p>
                        <p className="fs-14 color-text">{user?.email}</p>
                    </div>
                </div>

                <div className="flex flex-ai-center ml-40 ">

                    <div className="">
                        <div className="flex flex-ai-center">
                            <p className="fs-13-lh color-text">{user?.gimScore}</p>
                            <FontAwesomeIcon icon={solid("star")} className="fs-14 color-gim ml-4 mb-2" />
                        </div>
                        <p className="fs-13 color-text mt-4">{"Gim"}</p>
                    </div>

                    <div className="ml-40">
                        <div className="flex flex-ai-center">
                            <p className="fs-13-lh color-text">{user?.gimmerScore}</p>
                            <FontAwesomeIcon icon={solid("star")} className="fs-14 color-gimmer ml-4 mb-2" />
                        </div>
                        <p className="fs-13 color-text mt-4">{"Gimmer"}</p>
                    </div>

                </div>       

            </div>   

        </div>
    )
}

export default React.memo( CardUserBugReport )